import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import teaserImage from "@/assets/chlm-teaser.jpg";

const LongevityTeaser = () => {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden bg-primary">
      <img
        src={teaserImage}
        alt="Caribbean coastal sunrise with hibiscus and tropical botanicals"
        className="absolute inset-0 w-full h-full object-cover opacity-60"
        width={1600}
        height={900}
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary/85 via-primary/60 to-primary/30" />
      <div className="relative z-10 container mx-auto px-6">
        <div className="max-w-2xl">
          <p className="text-xs md:text-sm tracking-[0.3em] uppercase text-accent font-sans mb-4">
            New · A Caribbean Wellness Framework
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-primary-foreground leading-tight mb-5">
            The Caribbean Heritage Longevity Method™
          </h2>
          <p className="text-base md:text-lg text-primary-foreground/90 font-sans leading-relaxed mb-8">
            Rooted memory. Living future. A botanical, cultural, and culinary
            framework for longevity — drawn from the kitchens, gardens, and
            wisdom of St. Kitts and Nevis.
          </p>
          <Link to="/caribbean-heritage-longevity-method">
            <Button
              size="lg"
              variant="secondary"
              className="font-sans uppercase tracking-widest text-sm px-8"
            >
              Enter the Method <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LongevityTeaser;
